<script lang="ts">
    import { onMount } from 'svelte/internal'
    import ProspectCard from '../prospect/prospect-card.svelte'
    import { BusinessRepository } from '../../modules/prospectApi/business/business.repository'
    import { BusinessService } from '../../modules/prospectApi/business/business.service'
    import { Business } from '../../modules/prospectApi/business/business.entity'
    // ##############################################################################################################

    export let businessId: string

    const entityRep = new BusinessRepository()
    const entityS = new BusinessService(entityRep)

    let show = true
    let business: Business = new Business()

    async function loadItem() {
        try {
            show = true
            business = await entityS.getOne(businessId)
            console.log('business', business)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    onMount(async () => {
        await loadItem()
    })
</script>

<div class="mt-2 box">
    {#if !show}
        <ProspectCard {business} />
    {/if}
</div>

<style>
</style>
